module.exports = __webpack_public_path__ + "42d877ce1c7ff5fd679576c87cd33d68.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-4.png
// module id = 2333
// module chunks = 0